import { useEffect } from 'react';
import { useOutletContext } from 'react-router-dom';

import { useMember } from 'lib/hooks/queries/member/useMember';

import AgTablePage from 'components/shared/AgTablePage/AgTablePage';
import InviteMemberModal from 'components/Staff/components/InviteMemberModal';
import {
  isSubstepCompleted,
  resolveContinueAction
} from 'components/shared/OnboardingWizard/lib/resolveContinueAction';

import HeaderActions from '../HeaderActions';

import { getDefaultColumns } from './lib/helpers';

const WizardStaff = ({
  addFooterActions,
  mutateOrchestratorData,
  setHeaderButtonProps,
  onNext,
  orchestratorData,
  orchestratorLoading,
  wizardState
}) => {
  const { practice } = useOutletContext();
  const principalUserId = wizardState?.instance?.assigned_to;
  useEffect(() => {
    addFooterActions([
      {
        text: 'Continue',
        onClick: resolveContinueAction({
          isDirty: false,
          isCompleted: isSubstepCompleted(orchestratorData),
          hasExistingData: true,
          onConfirm: async () => mutateOrchestratorData(),
          onNext
        }),
        isDisabled: orchestratorLoading
      }
    ]);
  }, [orchestratorLoading, orchestratorData?.handlerStatus]);

  return (
    <div className="mb-4 flex flex-1 flex-col">
      <AgTablePage
        defaultColumns={getDefaultColumns(principalUserId)}
        defaultFilters={[]}
        useData={useMember}
        title="Staff member"
        name="members"
        noHeader
        actions={(props) => (
          <HeaderActions {...props} setMotionHeaderButtonProps={setHeaderButtonProps} />
        )}
        rowStyle={{ cursor: 'pointer' }}
        queryParams={{ practiceId: practice?.id }}
        ModalComponent={InviteMemberModal}
        autoHeight
        className="overflow-y-auto rounded-2xl border border-solid border-neutral-200 [&_.ag-root-wrapper]:border-0"
      />
    </div>
  );
};

export default WizardStaff;
